<header class="header" [class.scrolled]="isScrolled">
  <div class="container">
    <div class="header-content">
      
      <!-- Logo -->
      <a routerLink="/home" class="logo">
        <div class="logo-container">
          <img src="../../../assets/adicompany.png" alt="Aadinath Enterprises" class="logo-image">
          <div class="logo-text">
            <span class="logo-main">Aadinath Enterprises</span>
            <span class="logo-sub">Goods & Equipment</span>
          </div>
        </div>
      </a>

      <!-- Desktop Navigation -->
      <nav class="desktop-nav">
        <ul class="nav-links">
          <li>
            <a routerLink="/home" routerLinkActive="active" class="nav-link">
              <span class="nav-text">Home</span>
              <div class="nav-indicator"></div>
            </a>
          </li>
          <li>
            <a routerLink="/products" routerLinkActive="active" class="nav-link">
              <span class="nav-text">Products</span>
              <div class="nav-indicator"></div>
            </a>
          </li>
          <li>
            <a routerLink="/about" routerLinkActive="active" class="nav-link">
              <span class="nav-text">About</span>
              <div class="nav-indicator"></div>
            </a>
          </li>
          <li>
            <a routerLink="/contact" routerLinkActive="active" class="nav-link">
              <span class="nav-text">Contact</span>
              <div class="nav-indicator"></div>
            </a>
          </li>
        </ul>
      </nav>

      <!-- Header Actions -->
      <div class="header-actions">
       

        <!-- User Account -->
        <button class="action-btn" *ngIf="!isAuthenticated" (click)="openLoginModal()">
          <mat-icon>account_circle</mat-icon>
          <span class="action-tooltip">Login</span>
        </button>

        <!-- Admin Dashboard -->
        <button class="action-btn" *ngIf="isAdmin" (click)="navigateToAdminDashboard()">
          <mat-icon>dashboard</mat-icon>
          <span class="action-tooltip">Dashboard</span>
        </button>

        <!-- User Profile -->
        <button class="action-btn" *ngIf="isAuthenticated && !isAdmin" (click)="navigateToProfile()">
          <mat-icon>person</mat-icon>
          <span class="action-tooltip">Profile</span>
        </button>

        <!-- Logout -->
        <button class="action-btn" *ngIf="isAuthenticated" (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span class="action-tooltip">Logout</span>
        </button>

        <!-- Mobile Menu Button -->
        <button class="mobile-menu-btn" (click)="toggleMobileMenu()">
          <div class="hamburger" [class.active]="isMobileMenuOpen">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
          </div>
        </button>
      </div>

      <!-- Mobile Navigation -->
      <nav class="mobile-nav" 
           [@mobileMenu]="isMobileMenuOpen ? 'open' : 'closed'"
           *ngIf="isMobileMenuOpen"
           [@slideDown]>
        <div class="mobile-nav-overlay"></div>
        <ul class="mobile-nav-links">
          <li>
            <a routerLink="/home" 
               routerLinkActive="active" 
               class="mobile-nav-link"
               (click)="closeMobileMenu()">
              <mat-icon>home</mat-icon>
              <span>Home</span>
            </a>
          </li>
          <li>
            <a routerLink="/products" 
               routerLinkActive="active" 
               class="mobile-nav-link"
               (click)="closeMobileMenu()">
              <mat-icon>inventory</mat-icon>
              <span>Products</span>
            </a>
          </li>
          <li>
            <a routerLink="/about" 
               routerLinkActive="active" 
               class="mobile-nav-link"
               (click)="closeMobileMenu()">
              <mat-icon>info</mat-icon>
              <span>About</span>
            </a>
          </li>
          <li>
            <a routerLink="/contact" 
               routerLinkActive="active" 
               class="mobile-nav-link"
               (click)="closeMobileMenu()">
              <mat-icon>contact_mail</mat-icon>
              <span>Contact</span>
            </a>
          </li>
          <li *ngIf="isAdmin">
            <a routerLink="/admin/dashboard" 
               routerLinkActive="active" 
               class="mobile-nav-link"
               (click)="closeMobileMenu()">
              <mat-icon>dashboard</mat-icon>
              <span>Dashboard</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</header>

<!-- Login Modal -->
<app-login-modal 
  *ngIf="showLoginModal"
  [isVisible]="showLoginModal"
  (loginSuccess)="onLoginSuccess()"
  (close)="closeLoginModal()">
</app-login-modal>
